import { Col } from 'antd'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import RemindersManager from '../../component/reminders/reminders.manager'
import ApolloClientService from '../../services/apolloclient.service'
import '../../css/event.scss'
import util from '../../util/util'
import { Redirect } from 'react-router-dom'
import { getHelp, pages } from '../../tutorials'

const apolloService = new ApolloClientService()

// The Reminders page — the coded catalog editor (system → company → clinic
// layers), the ONLY reminder system (docs/REPORT_REMINDERS_CONVERGENCE.md).
// The legacy surgery-timeline event editor that used to live here was retired
// at cutover; its content was folded into the coded catalog defaults.
// Scopes to the clinic when one is selected, otherwise to the company.
const Events = (props) => {
  const customerid = props.customer && props.customer._id
  const companyid =
    (props.customer && props.customer.company) ||
    (props.company && props.company._id)

  // The clinic's configured discipline: its active surgery types (knee/hip/pt…).
  // Drives the "Applies to" options in the reminders editor so a clinic only
  // sees the types it actually treats. Company scope uses the full active list
  // instead (see companySurgeryTypes below).
  const clinicSurgeryTypes = (
    (props.customer && props.customer.surgerytypes) ||
    []
  )
    .filter((st) => st && st.active !== false && st.name)
    .map((st) => String(st.name).toLowerCase())

  // Company scope has no clinic-specific discipline list, so source the "Applies
  // to" options from the full set of active surgery types (knee/hip/pt…) — the
  // clinic path narrows to what it treats, the company path sees all of them.
  const [companySurgeryTypes, setCompanySurgeryTypes] = useState([])
  useEffect(() => {
    let cancelled = false
    apolloService
      .getActiveSurgeryTypes()
      .then((types) => {
        if (cancelled) return
        setCompanySurgeryTypes(
          (types || [])
            .filter((st) => st && st.active !== false && st.name)
            .map((st) => String(st.name).toLowerCase())
        )
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  useEffect(() => {
    getHelp(pages.REMINDER)
  }, [])

  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <Col className='events-container'>
      <div style={{ padding: '16px 24px' }}>
        <h2 style={{ marginBottom: 4 }}>
          {customerid ? 'Clinic Reminders' : 'Company Reminders'}
        </h2>
        {customerid ? (
          <RemindersManager
            scope='clinic'
            customerid={customerid}
            surgeryTypes={clinicSurgeryTypes}
          />
        ) : companyid ? (
          <RemindersManager
            scope='company'
            companyid={companyid}
            surgeryTypes={companySurgeryTypes}
          />
        ) : null}
      </div>
    </Col>
  )
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    customer: state.profile.customer,
    company: state.profile.company,
    user: state.profile.user,
  }
}

export default connect(mapStateToProps)(Events)
